import { motion } from "framer-motion";

export const easeOut = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 30, className = "", once = true }) {
  return (
    <motion.div
      className={`reveal-target ${className}`}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.65, delay, ease: easeOut }}
    >
      {children}
    </motion.div>
  );
}

export function MaskLines({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.14 }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span className={`mask-line ${lineClassName}`} key={i} aria-hidden="true">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.85, delay: delay + i * stagger, ease: easeOut }}
            dangerouslySetInnerHTML={{ __html: line }}
          />
        </span>
      ))}
    </span>
  );
}

export function FadeIn({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay, ease: easeOut }}
    >
      {children}
    </motion.div>
  );
}
